import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core';

import styles from './AppointmentsListContainer.styles';

interface IAppointmentsListContainer extends WithStyles<typeof styles> {}

const AppointmentsListContainer: React.FunctionComponent<IAppointmentsListContainer> = (props) => {
  const { children, classes } = props;

  return <div className={classes.root}>{children}</div>;
};

export default withStyles(styles)(AppointmentsListContainer);
